import { CoverageRing } from './ProgressRing';

type PolicyCoverageRowProps = {
  title: string;
  description: string;
  enabledCount: number;
  totalCount: number;
};

export const PolicyCoverageRow: React.FC<PolicyCoverageRowProps> = ({
  title,
  description,
  enabledCount,
  totalCount,
}) => {
  return (
    <div className="grid grid-cols-[48px_1fr] items-center gap-3 py-3 w-full overflow-hidden border-b border-border last:border-none">
      <CoverageRing value={enabledCount} total={totalCount} />
      <div className="flex flex-col gap-0.5 min-w-0 overflow-hidden">
        <h3 className="text-sm font-medium truncate">{title}</h3>
        <p className="text-xs text-muted-foreground leading-snug line-clamp-2">
          {description}
        </p>
        <p className="text-xs font-bold text-foreground mt-2">
          {enabledCount} enabled out of {totalCount}
        </p>
      </div>
    </div>
  );
};
